const httpProvider = {
  pdsServer: {
    url: window.location.protocol + '//' + window.location.hostname,
    port: window.location.protocol === 'https:' ? '443' : '8080'
  },
  pdaServer: {
    url: window.location.protocol + '//' + 
    (window.location.hostname.includes('ui') ?
       window.location.hostname.replace('ui', 'mc') :
       window.location.hostname.replace('pda', 'pda-mc')),
    port: window.location.protocol === 'https:' ? '443' : '8080'
  },
  restResourcesSuffix: {
    authToken: "/auth/token",
    authCheck: "/auth/check",
    authLogin: "/auth/login",
    uploadFile: '/upload',
    downloadFile: '/download',
    list: '/list'
  }
}

const paths = {
  authPath: `${httpProvider.pdaServer.url}${httpProvider.restResourcesSuffix.authCheck}`,
  authToken: `${httpProvider.pdaServer.url}${httpProvider.restResourcesSuffix.authToken}`,
  loginPath: `${httpProvider.pdaServer.url}${httpProvider.restResourcesSuffix.authLogin}`,
  samlLogoutPath: `https://login.microsoftonline.com/common/wsfederation?wa=wsignout1.0`,
  uploadPath: (target) => `${httpProvider.pdaServer.url}${httpProvider.restResourcesSuffix.uploadFile}/${target}`,
  downloadPath: (target) => `${httpProvider.pdaServer.url}${httpProvider.restResourcesSuffix.downloadFile}/${target}`,
  listPath: (target) => `${httpProvider.pdaServer.url}${httpProvider.restResourcesSuffix.list}/${target}`,
}

const routesProvider = {
  basename: '/ui/#',
  sections: {
    onlinePrices: {
      title: 'Online Prices',
      authPath: paths.authPath,
      loginPath: paths.loginPath,
      logoutPath: paths.samlLogoutPath
    },
    onlinePromotions: {
      title: 'Online Promotions',
      authPath: paths.authPath,
      loginPath: paths.loginPath,
      logoutPath: paths.samlLogoutPath
    },
    googleShopping: {
      title: 'Google Shopping',
      authPath: paths.authPath,
      loginPath: paths.loginPath,
      logoutPath: paths.samlLogoutPath
    },
    productCatalogue: {
      title: 'Product Catalogue',
      authPath: paths.authPath,
      loginPath: paths.loginPath,
      logoutPath: paths.samlLogoutPath
    },
    salesContact: {
      title: 'Sales Contact',
      authPath: paths.authPath,
      loginPath: paths.loginPath,
      logoutPath: paths.samlLogoutPath
    },
    searchEngineOptimization: {
      title: 'Search Engine Optimization',
      authPath: paths.authPath,
      loginPath: paths.loginPath,
      logoutPath: paths.samlLogoutPath
    }
  },
  pages: [
    {
      path: '/',
      title: 'Welcome to Pricing Data Application',
      id: 'home',
      description: '',
      pageTemplate: 'Home',
      exact: true,
      restricted: true,
    },
    {
      path: '/ui',
      title: 'Welcome to Pricing Data Application',
      id: 'home',
      description: '',
      pageTemplate: 'Home',
      exact: true,
      restricted: true,
    },
    {
      path: '/home',
      title: 'Home',
      id: 'home',
      description: 'Welcome to PDA',
      pageTemplate: 'Home',
      exact: true,
      restricted: true,
    },
    {
      path: '/403',
      title: '403/Forbidden',
      id: '403',
      description: 'You are not authorized',
      pageTemplate: 'Forbidden',
      exact: true,
      restricted: false,
    },
    {
      path: '/404',
      title: '404 Page not found !',
      id: '404',
      description: 'We are sorry, but the page you requested was not found.',
      pageTemplate: 'NotFound',
      exact: true,
      restricted: false,
    },
    {
      path: '/login',
      title: 'Login',
      id: 'login',
      description: 'Please login with your SSO credentials',
      pageTemplate: 'Login',
      exact: true,
      restricted: false,
    },
    {
      path: '/logout',
      title: 'Logout',
      id: 'logout',
      description: 'You are logged out successfully!',
      pageTemplate: 'Login',
      exact: true,
      restricted: false,
    },
    {
      path: '/products',
      title: 'Products',
      id: 'online-prices-product',
      description: 'List of  Product Line Codes and their corresponding product names',
      sectionKey: 'onlinePrices',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/sap-regions',
      title: 'SAP Regions',
      id: 'online-prices-sap-region',
      description: 'The SAP region ids and names',
      sectionKey: 'onlinePrices',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/purchase-types',
      title: 'Purchase Types',
      id: 'online-prices-purchase-type',
      description: 'List of the subscription types: their identification (strawmanDescription), their marketing name, the periodicity and the count of the billing plus the level of support (BASIC/ADVANCED)',
      sectionKey: 'onlinePrices',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/consumer-applications',
      title: 'Consumer Applications',
      id: 'online-prices-consumer-application',
      description: 'ONLINE or SRP (public Reseller prices)',
      sectionKey: 'onlinePrices',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/application-countries',
      title: 'Consumer Application Countries',
      id: 'online-prices-consumer-application-country',
      description: "For each locale (country/language code), pricingSourceKey and ConsumerApplication the table provides several crucial information",
      info: "Important: You can not delete a row that has been previously imported. If you change the pricingSourceKey it will create a new row with that one. But you can disable a row by setting the 'disabled' attribute to 1",
      sectionKey: 'onlinePrices',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/payment-methods',
      title: 'Payment Methods',
      id: 'online-prices-payment-method',
      description: 'This table contains consolidated information about the different payment icons supported by Autodesk across the globe. Be careful, it is case sensitive. We recommend to use only lowercase name',
      sectionKey: 'onlinePrices',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/application-country-payments',
      title: 'Consumer Application Country Payments',
      id: 'online-prices-consumer-application-country-payment',
      description: 'List the payment methods supported by different countries, term-wise',
      sectionKey: 'onlinePrices',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true

    },
    {
      path: '/product-language-packs',
      title: 'Product Language Packs',
      id: 'online-prices-product-language-pack',
      description: 'List the available languages for each Autodesk product (PLC)',
      sectionKey: 'onlinePrices',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/promotions',
      title: 'Promotions',
      id: 'online-promotions',
      description: 'All the valid promocode/id per subscription term and country',
      sectionKey: 'onlinePromotions',
      pageTemplate: 'ImportAndExportPage',
      restricted: true,
      exact: false,
      showUploadCard: true
    },
    {
      path: '/whiteList',
      title: 'White List',
      id: 'online-prices-whitelist',
      description: 'Update White List each time a PLC is inserted or removed for any country in the Global Commerce or PELICAN',
      sectionKey: 'onlinePrices',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/google-shopping-products',
      title: 'Products List',
      id: 'google-shopping-products',
      description: 'List of all the products in Google Merchant Center',
      sectionKey: 'googleShopping',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/google-shopping-store-configuration',
      title: 'Store Configuration',
      id: 'google-shopping-store-configuration',
      description: 'List of all the store in Google Merchant Center',
      sectionKey: 'googleShopping',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/product-catalogue-products',
      title: 'Product Catalogue',
      id: 'product-catalogue-products',
      description: 'List of all the products in Product Catalogue',
      sectionKey: 'productCatalogue',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/product-catalogue-localized-properties',
      title: 'Products Localized Properties',
      id: 'product-catalogue-localized-properties',
      description: 'All the localized properties for products in Google Merchant Center',
      sectionKey: 'productCatalogue',
      pageTemplate: 'Locale',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/product-catalogue-cloudrelease',
      title: 'CloudRelease Products',
      id: 'product-catalogue-cloudrelease',
      description: 'List of all the CloudRelease Products',
      sectionKey: 'productCatalogue',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/cloud-credit',
      title: 'Cloud Credits',
      id: 'online-prices-cloud-credit',
      description: 'Update the list of locales/priceIds to provide GUAC cart link for Cloud Credits subscription',
      info: 'Data is cached only for a day',
      sectionKey: 'onlinePrices',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/numbersPerCountry',
      title: 'Country Wise',
      id: 'sales-contact-numbers-per-country',
      description: 'Repository for sales contact numbers per Country',
      sectionKey: 'salesContact',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/numbersPerCountryAndProduct',
      title: 'Product Wise',
      id: 'sales-contact-numbers-per-country-product',
      description: 'Repository for sales contact numbers per Country and Product',
      sectionKey: 'salesContact',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    },
    {
      path: '/imageRepository',
      title: 'Image Repository',
      id: 'seo-image-repository',
      description: 'Repository for Product Images',
      sectionKey: 'searchEngineOptimization',
      pageTemplate: 'ImportAndExportPage',
      exact: false,
      restricted: true,
      showUploadCard: true
    }
  ]
}

export {routesProvider, httpProvider, paths};
